import React, { useEffect, useState } from 'react';
import { TextField, Button, Grid, InputAdornment } from '@mui/material';

import EmailIcon from '@mui/icons-material/Email';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PhoneIcon from '@mui/icons-material/Phone';
import HomeIcon from '@mui/icons-material/Home';
import {
  FolderZip,
  LocalHospitalOutlined,
  LocalHospitalTwoTone,
  LocationCity,
  LocationCityOutlined,
  LocationCityTwoTone,
} from '@mui/icons-material';
import { Col, Form, Row } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from '../../redux/store';
import { deleteCenter, updateCenter, updateCenterStatus } from '../../redux/slices/programAdmin';
import DeleteModal from '../modal/DeleteModal';

function EditCenterForm() {
  const navigate = useNavigate();

  const [centerData, setCenterData] = useState({
    name: '',
    address1: '',
    address2: '',
    city: '',
    state: '',
    zip: '',
    phone: '',
    description: `This is for Center`
  });

  const [modalShow, setModalShow] = useState(false);
  
  const dispatch = useDispatch();
  const { center } = useSelector((state)=> state.programAdmin);

  useEffect(()=>{
      setCenterData({
        name: center?.name,
        address1: center?.address?.address1,
        address2: center?.address?.address2,
        city: center?.address?.city,
        state: center?.address?.state,
        zip: center?.address?.zip,
        phone: center?.contactNumber,
        description: center?.description
      });
  },[center]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setCenterData({
      ...centerData,
      [name]: value,
    });
  };

  const handleChangeNumber = (event) => {
    const { name, value } = event.target;
    const val = value.replace(/\D/g, '');
    const cleanValue = val.slice(0, 10);
    setCenterData({
      ...centerData,
      [name]: cleanValue,
    });
  };

  const convertPhoneNumber = (number) =>{
    if(number){
      const cleanNumber = number.replace(/-/g, '');
      const formattedNumber = cleanNumber.replace(/(\d{3})(\d{3})(\d{4})/, (match, p1, p2, p3) => {
        if (p3) return `${p1}-${p2}-${p3}`;
        if (p2) return `${p1}-${p2}`;
        return p1;
      });
      return formattedNumber;
    }
      return '';
  }

  const handleSubmit = async (event) => {
    event.preventDefault();

    await dispatch(updateCenter(center?.id,centerData));
    navigate("/dashboard/center");    
  };

  const handleDelete = async () => {
    await dispatch(deleteCenter(center?.id));
    navigate("/dashboard/center");
  }

  const deactivateCenter = async () => {
    await dispatch(updateCenterStatus(center?.id, !center?.status));
    navigate(0);
  }

  return (
    <form onSubmit={handleSubmit}>
      <Grid container spacing={2}>

        <Grid item xs={12} marginTop={2}>
          <small className="text-secondary" style={{ fontWeight: '500' }}>
            Center Details
          </small>
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            name="name"
            variant="outlined"
            placeholder="Center Name"
            value={centerData?.name}
            onChange={handleChange}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <LocalHospitalTwoTone />
                </InputAdornment>
              ),
            }}
            required
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            name="address1"
            variant="outlined"
            placeholder="Address 1"
            value={centerData.address1}
            onChange={handleChange}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <LocationOnIcon />
                </InputAdornment>
              ),
            }}
            required
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            name="address2"
            placeholder="Address 2"
            variant="outlined"
            value={centerData.address2}
            onChange={handleChange}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <LocationOnIcon />
                </InputAdornment>
              ),
            }}
            
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            name="city"
            placeholder="City"
            variant="outlined"
            value={centerData.city}
            onChange={handleChange}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <LocationCity />
                </InputAdornment>
              ),
              inputProps: { inputMode: 'text', pattern: '[A-Za-z]*' }
            }}
            required
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            name="state"
            placeholder="State"
            variant="outlined"
            value={centerData.state}
            onChange={handleChange}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <LocationCityTwoTone />
                </InputAdornment>
              ),
              inputProps: { inputMode: 'text', pattern: '[A-Za-z]*' }
            }}
            required
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            name="zip"
            placeholder="ZIP"
            variant="outlined"
            value={centerData.zip}
            onChange={handleChange}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <FolderZip />
                </InputAdornment>
              ),
              inputProps: { inputMode: 'numeric', pattern: '[0-9]*' }
            }}
            required
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            name="phone"
            placeholder="Phone"
            variant="outlined"
            value={convertPhoneNumber(centerData.phone)}
            onChange={handleChangeNumber}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <PhoneIcon />
                </InputAdornment>
              ),
            }}
            required
          />
        </Grid>
      </Grid>

      <Row className="mt-5 align-items-center">
        <Col className="text-end">
        <Button
            type="button"
            onClick={() => setModalShow(true)}
            variant="contained"
            className="me-3 btn btn-outline-danger"
            style={{
              padding: '13px 25px',
            }}
          >
            Delete
          </Button>
          <Button
            type="button"
            onClick={() => deactivateCenter()}
            variant="contained"
            className="me-3"
            style={{
              background: '#6A6A6A',
              padding: '13px 25px',
              border: 'none',
              boxShadow: 'rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px',
            }}
          >
            {center?.status ? 'Deactivate':'Activate'} Center
          </Button>
          <Button
            type="submit"
            variant="contained"
            style={{
              background: 'linear-gradient(to top, #11448A 0%, #176CD9 100%)',
              padding: '13px 25px',
              border: 'none',
              boxShadow: 'rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px',
            }}
          >
            Save Changes
          </Button>
        </Col>
      </Row>
      
      <DeleteModal
        show={modalShow}
        dltModalTxt={'Are you sure you want to delete this center?'}
        onHide={() => setModalShow(false)}
        onDelete={()=> handleDelete()}
      />
    </form>
  );
}

export default EditCenterForm;
